const siteData = require("./siteData");
const careIpdModules = require("./careIpdModules");
const { createBreadcrumbList, createWebPageSchema, createFaqPageSchema } = require("../utils/seo");

const faqs = [
  ["What does Care IPD help manage?", "Care IPD brings patient registration, IPD and OPD workflows, ward and bed management, billing and pharmacy into one desktop application."],
  ["Can we manage wards, rooms and beds?", "The existing modules include ward, room and bed settings, bed allocation, bed transfers and a ward/bed board."],
  ["Does it include outpatient workflows?", "Yes. OPD features include registration, token and doctor queues, consultations, prescriptions, billing and OPD-to-IPD conversion."],
  ["What should we discuss in a demo?", "Tell us about your hospital’s departments, patient workflows and current software. Ask the team to walk through the modules you need and confirm setup requirements, data migration options and pricing for your hospital."],
];
const title = "Care IPD Hospital Management Software | Book a Demo";
const description = "Manage patient records, IPD, OPD, beds, billing and pharmacy with Care IPD hospital management software. Explore all seven modules and book a demo with QBITS9.";
const canonicalUrl = `${siteData.siteUrl}/hospital-management-software`;
const schemas = [
  createWebPageSchema({ name: "Care IPD Hospital Management Software", description, path: "/hospital-management-software" }),
  createBreadcrumbList([{ name: "Home", path: "/" }, { name: "Care IPD", path: "/hospital-management-software" }]),
  createFaqPageSchema({
    faqs: faqs.map(([question, answer]) => ({ question, answer })),
    path: "/hospital-management-software",
    name: "Care IPD hospital management software FAQs",
    description,
  }),
  {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "@id": `${canonicalUrl}#software`,
    name: "Care IPD",
    alternateName: "CareIPD",
    url: canonicalUrl,
    description,
    applicationCategory: "BusinessApplication",
    applicationSubCategory: "Hospital management software",
    featureList: careIpdModules.flatMap(module => module.groups.flatMap(group => group.items)),
    publisher: { "@type": "Organization", name: siteData.brandName, url: siteData.siteUrl },
    // No price, rating, operating system or compliance claims without verified data.
  },
];

module.exports = { title, description, canonicalUrl, faqs, schemas, image: "/images/careipd/social-preview.png", imageAlt: "Care IPD hospital management software by QBITS9 — IPD, OPD, billing and pharmacy" };
